// src/components/Account/Avatar/MusicNote.tsx
import React from 'react';
import {
  PiMusicNote,
  PiMusicNoteDuotone,
  PiMusicNoteFill,
  PiMusicNoteLight,
  PiMusicNoteSimple,
  PiMusicNoteSimpleFill,
  PiMusicNoteSimpleLight,
  PiMusicNotes,
  PiMusicNotesDuotone,
  PiMusicNotesFill,
  PiMusicNotesLight,
  PiMusicNotesSimple,
  PiMusicNotesSimpleFill,
  PiMusicNotesSimpleLight,
} from 'react-icons/pi';

// Musical notes for avatars
const MUSICAL_NOTES = [
  PiMusicNote,
  PiMusicNoteFill,
  PiMusicNoteLight,
  PiMusicNoteSimple,
  PiMusicNoteSimpleFill,
  PiMusicNoteSimpleLight,
  PiMusicNoteDuotone,
  PiMusicNotes,
  PiMusicNotesFill,
  PiMusicNotesLight,
  PiMusicNotesSimple,
  PiMusicNotesSimpleFill,
  PiMusicNotesSimpleLight,
  PiMusicNotesDuotone,
];

// Brand-matching colors for musical notes
const NOTE_COLORS = [
  '#0c8ce9', // Your accent blue
  '#2563eb', // Blue variant
  '#7c3aed', // Purple
  '#dc2626', // Red
  '#ea580c', // Orange
  '#ca8a04', // Yellow/gold
  '#16a34a', // Green
  '#0891b2', // Cyan
  '#c2410c', // Orange red
  '#9333ea', // Violet
  '#059669', // Emerald
  '#0f766e', // Teal
];

interface MusicNoteProps {
  name: string;
  size: number;
  fontSize: number;
}

// Generate single note and color based on user name
function generateMusicAvatar(name: string) {
  const safeName = (name || 'Anonymous').trim();
  let hash = 0;

  // Create hash from name for stability
  for (let i = 0; i < safeName.length; i++) {
    hash = safeName.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Select note and color based on hash
  const noteIndex = Math.abs(hash) % MUSICAL_NOTES.length;
  const colorIndex = Math.abs(hash >> 8) % NOTE_COLORS.length;

  return {
    NoteComponent: MUSICAL_NOTES[noteIndex],
    color: NOTE_COLORS[colorIndex],
  };
}

const MusicNote: React.FC<MusicNoteProps> = ({ name, size, fontSize }) => {
  const { NoteComponent, color } = generateMusicAvatar(name);
  // Make note bigger - SVG icons scale better than Unicode
  const noteSize = fontSize * 1.5;

  return (
    <div
      className='flex items-center justify-center rounded-full border'
      style={{
        width: size,
        height: size,
        backgroundColor: '#FFFFFF',
      }}
    >
      <NoteComponent
        size={noteSize}
        color={color}
        style={{
          display: 'block', // Ensure proper centering
        }}
      />
    </div>
  );
};

export default MusicNote;
